import * as z from '@exact-magic/validation';
import { User } from './user.base';

export const UpdateProfile = User.pick({
  name: true,
  picture: true,
});
export type UpdateProfile = z.input<typeof UpdateProfile>;
